import { render, staticRenderFns } from "./servicePromise.vue?vue&type=template&id=acb5d91e&scoped=true&"
import script from "./servicePromise.vue?vue&type=script&lang=js&"
export * from "./servicePromise.vue?vue&type=script&lang=js&"
import style0 from "./servicePromise.vue?vue&type=style&index=0&id=acb5d91e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb5d91e",
  null
  
)

export default component.exports